import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
export function HoursTable() {
  const {
    t
  } = useLanguage();
  const times = ['Closed', '9 AM - 7 PM', '9 AM - 7 PM', '9 AM - 7 PM', '9 AM - 7 PM', '9 AM - 5 PM', 'Closed'];
  return <div className="my-12 bg-[#111111] border border-[#c9a84c]/30 p-8 md:p-12" data-id="element-42">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-43">
        <div data-id="element-44">
          <h3 className="font-['Playfair_Display'] text-2xl text-white mb-6" data-id="element-45">
            {t.hours.locationHeading}
          </h3>
          <div className="space-y-4 text-lg text-[#f5f0e8]" data-id="element-46">
            <p data-id="element-47">
              <strong className="text-[#c9a84c] font-normal" data-id="element-48">
                {t.hours.addressLabel}
              </strong>
              <br data-id="element-49" />
              3964 Curtiss Pkwy
              <br data-id="element-50" />
              Virginia Gardens, FL 33166
            </p>
            <p data-id="element-51">
              <strong className="text-[#c9a84c] font-normal" data-id="element-52">
                {t.hours.phoneLabel}
              </strong>
              <br data-id="element-53" />
              <a href="tel:3058853240" className="hover:text-[#c9a84c] transition-colors" data-id="element-54">
                (305) 885-3240
              </a>
            </p>
            <p data-id="element-55">
              <strong className="text-[#c9a84c] font-normal" data-id="element-56">
                {t.hours.amenitiesLabel}
              </strong>
              <br data-id="element-57" />
              {t.hours.amenitiesValue}
            </p>
          </div>
        </div>

        <div data-id="element-58">
          <h3 className="font-['Playfair_Display'] text-2xl text-white mb-6" data-id="element-59">
            {t.hours.hoursHeading}
          </h3>
          <ul className="space-y-3 text-lg text-[#f5f0e8]" data-id="element-60">
            {t.hours.days.map((day, index) => {
            const isClosed = times[index] === 'Closed';
            const displayTime = isClosed ? t.hours.closed : times[index];
            return <li key={index} className="flex justify-between border-b border-[#c9a84c]/10 pb-2 last:border-0" data-id="element-61">
                  <span data-id="element-62">{day}</span>
                  <span className={isClosed ? 'text-gray-500' : 'text-white'} data-id="element-63">
                    {displayTime}
                  </span>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </div>;
}